import {filter, includes} from 'lodash';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Select, SelectProps} from 'components';
import {ExternalIntegrationPurpose} from 'enums';
import {TRANSLATION_KEYS} from 'locale';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.SESSION.EXTERNAL_INTEGRATION_PURPOSE;

type Props = {
    value: ExternalIntegrationPurpose;
    purposes?: ExternalIntegrationPurpose[];
    className?: string;
    onChange: (value: ExternalIntegrationPurpose) => void;
} & Partial<SelectProps>;

export const ExternalIntegrationPurposeSelect: React.FC<Props> = ({value, purposes, className, onChange, ...rest}) => {
    const {t} = useTranslation();

    const chatbotOptions = useMemo(() => filter([
        {id: ExternalIntegrationPurpose.ClientTextChat, name: t(T_KEYS.CLIENT_TEXT_CHAT)},
        {id: ExternalIntegrationPurpose.ClientVoice, name: t(T_KEYS.CLIENT_VOICE)},
        {id: ExternalIntegrationPurpose.AgentTextChatSuggestions, name: t(T_KEYS.TEXT_SUGGESTIONS)},
        {id: ExternalIntegrationPurpose.AgentAudioSuggestions, name: t(T_KEYS.AUDIO_SUGGESTIONS)},
        {id: ExternalIntegrationPurpose.STT, name: t(T_KEYS.STT)},
        {id: ExternalIntegrationPurpose.TTS, name: t(T_KEYS.TTS)},
        {id: ExternalIntegrationPurpose.ClientConnect, name: t(T_KEYS.CLIENT_CONNECT)},
        {id: ExternalIntegrationPurpose.ConversationSummary, name: t(T_KEYS.CONVERSATION_SUMMARY)},
        {id: ExternalIntegrationPurpose.Translation, name: t(T_KEYS.TRANSLATION)},
        {id: ExternalIntegrationPurpose.Avatar, name: t(T_KEYS.AVATAR)},
        {id: ExternalIntegrationPurpose.TextChatCompliance, name: t(T_KEYS.TEXT_CHAT_COMPLIANCE)},
        {id: ExternalIntegrationPurpose.AudioCompliance, name: t(T_KEYS.AUDIO_COMPLIANCE)},
        {id: ExternalIntegrationPurpose.AgentChatbot, name: t(T_KEYS.AGENT_CHATBOT)}
    ], ({id}) => !purposes || includes(purposes, id)),
    [t, purposes]);

    return (
        <Select
            {...rest}
            placeholder={t(T_KEYS.LABEL)}
            value={value}
            options={chatbotOptions}
            valueAs='id'
            className={className}
            onChange={onChange}
        />
    );
};